import { fork, put, take, all } from 'redux-saga/effects';
import moment from 'moment';
import { SAVE_TITLE } from 'Reducers/dataModels';
import bindAndHandleEvents from 'Lib/bindAndHandleEvents';
import { CREATE_PAGE_VIEWER, SET_IFRAME_ATTRIBUTES, GET_TOC } from './actions';
import { notifications, CREATE_PAGE_VIEWER_FAIL } from 'PipeRouter';

function* createPageViewer(createPageObject) {
  while (true) {
    const { data:createPageObject } = yield take(CREATE_PAGE_VIEWER);
 
    const start = moment(new Date().getTime());

    logger.info('CREATE_PAGE_VIEWER', createPageObject);

    try {
      const [vsViewer, data] = yield new Promise((resolve, reject) => {
        const result = Jigsaw.createPageViewer(createPageObject, e => {
          const LAG = moment(new Date().getTime()).diff(start, 'seconds', true);

          logger.info('CREATE_PAGE_VIEWER_RESPONSE', { LAG, e });

          if (e.code !== 200) {
            throw reject(e);
          }
          resolve([result, e.data]);
        });
      });
      window.vsViewer = vsViewer;
      window.vsViewer.Viewport.setAutofocus(false);

      logger.info('CREATE_PAGE_VIEWER_SUCCEEDED');
      yield fork(bindAndHandleEvents);

      yield all([
        put({ type: SAVE_TITLE, title: data.title }),
        put({ type: GET_TOC }),
        put({ type: SET_IFRAME_ATTRIBUTES }),
      ]);
    } catch (err) {
      logger.error('CREATE_PAGE_VIEWER_FAIL', { err });
      yield put(notifications(CREATE_PAGE_VIEWER_FAIL));
    }
  }
}


export default createPageViewer;
